import * as React from "react";
const SvgTeamMember = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="#082B60"
      d="M9.836 0a6.643 6.643 0 0 0-6.637 6.637c0 3.591 2.808 6.498 6.47 6.624.111-.014.223-.014.307 0h.097a6.62 6.62 0 0 0 6.4-6.624A6.643 6.643 0 0 0 9.836 0M16.936 16.976c-3.899-2.599-10.257-2.599-14.183 0C.978 18.164 0 19.771 0 21.489c0 1.72.978 3.312 2.739 4.486 1.956 1.313 4.527 1.97 7.098 1.97s5.142-.657 7.099-1.97c1.76-1.188 2.738-2.78 2.738-4.514-.014-1.718-.978-3.311-2.738-4.485M25.192 7.46c.223 2.71-1.705 5.085-4.374 5.407h-.07c-.084 0-.168 0-.237.028-1.356.07-2.6-.364-3.536-1.16 1.44-1.286 2.264-3.214 2.096-5.31a6.5 6.5 0 0 0-1.076-3.046 5.02 5.02 0 0 1 7.196 4.08"
    />
    <path
      fill="#082B60"
      d="M27.985 20.388c-.112 1.355-.978 2.529-2.432 3.325-1.397.769-3.158 1.132-4.904 1.09 1.006-.908 1.593-2.04 1.704-3.242.14-1.732-.684-3.395-2.333-4.723-.936-.74-2.026-1.327-3.214-1.76 3.088-.895 6.973-.294 9.362 1.635 1.286 1.034 1.942 2.333 1.817 3.675"
    />
  </svg>
);
export default SvgTeamMember;
